import axios from "axios";

export const state = {
    runningloans: [],
};

export const getters = {
    runningloans: (state) => state.runningloans,
};

export const mutations = {
    setRunningLoans(state, newValue) {
        state.runningloans = newValue;
    },
};

export const actions = {
    async fetchRunningLoans({ commit }) {
        await axios.get("loans/running").then((res) => {
            commit("setRunningLoans", res.data.running_loans);
        });
    },
};
